import { defineComponent as _defineComponent } from 'vue'
import { IconWrapper } from 'ui-shared-components';
import IconS3 from '@white-label-icon/icons-s3';
import IconLink from 'libraries/@white-label-icon/icon-link/src/lib/icon-link.vue';


export default /*#__PURE__*/_defineComponent({
  __name: 'travel-insurance-eligibility',
  props: {
    loading: { type: Boolean, default: false },
    standalone: { type: Boolean, default: false }
  },
  setup(__props: any) {

const props = __props as { loading: boolean, standalone: boolean };



const skeletonLines = [
  'w-full',
  'w-full',
  'w-2/3',
  'w-2/3',
  'w-1/3',
];

return { __sfc: true,props, skeletonLines, IconWrapper, IconS3, IconLink }
}

})